import { useEffect, useState } from 'react';
import { User } from 'domains/User';
import { IUserRepository } from 'repository/U006/IUserRepository';
import { UserRepository } from 'repository/U006/UserRepository';

type UserResponse = {
  user: User;
  applicant_revision: number;
  user_info_revision: number;
};

export function useGetUser(
  userId: string
): [UserResponse | undefined, boolean, Error | null, () => void] {
  const [loading, setLoading] = useState<boolean>(true);
  const [user, setUser] = useState<UserResponse>();
  const [err, setError] = useState<Error | null>(null);

  const [refreshCount, setRefreshCount] = useState<number>(0);
  const refresh = () => setRefreshCount(refreshCount + 1);

  const fetchUser = async (userId: string, cancellation: AbortSignal) => {
    const repository: IUserRepository = new UserRepository();

    return await repository.get(userId, cancellation);
  };

  useEffect(() => {
    if (!userId) {
      return;
    }
    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      setLoading(true);
      setError(null);
      try {
        const user = await fetchUser(userId, cancellation);
        setUser(user);
      } catch (err) {
        console.error(err);
        setUser(undefined);
        setError(err instanceof Error ? err : new Error(`unknown error. ${err}`));
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      // controller.abort()
    };
  }, [userId, refreshCount]);

  return [user, loading, err, refresh];
}
